import React, { forwardRef } from 'react';
import MUIIconButton, {
  IconButtonProps as MUIIconButtonProps,
} from '@material-ui/core/IconButton';

interface IconButtonProps extends MUIIconButtonProps {}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return <MUIIconButton {...props} ref={ref} disableRipple />;
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;
